import axios from "axios";

import { ApiResult } from "../models/ApiResult";
import { OtpResult } from "../models/OtpResult";

const gateWayURL = import.meta.env.RAM_API_GATEWAY_URL;
const ocpApimSubscriptionKey = import.meta.env.RAM_OCP_APIM_SUBSCRIPTION_KEY;
const heartbeatUrl = import.meta.env.RAM_HEARTBEAT_URL;
const localServiceUrl = import.meta.env.RAM_LOCALSERVICE_URL;

const sendOtpEndpoint = "/SendOTP";
const validateOtpEndpoint = "/ValidateOTP";

export const MfaAPI = axios.create({
  baseURL: `${gateWayURL}/Authentication/api/v1/MFA`,
  headers: {
    "Ocp-Apim-Subscription-Key": ocpApimSubscriptionKey,
    "Ocp-Apim-Trace": "true",
    "Access-Control-Allow-Origin": "true",
  },
});
export const LocalAPI = axios.create({
  baseURL: localServiceUrl,
  timeout: 1000,
});

export const Services = axios.create({
  baseURL: heartbeatUrl,
});

export default {
  sendOtp(email: string) {
    return MfaAPI.get<ApiResult<OtpResult>>(`${sendOtpEndpoint}/${email}`);
  },
  validateOtp(email: string, otp: string) {
    return MfaAPI.get<ApiResult<string>>(
      `${validateOtpEndpoint}/${email}/${otp}`,
    );
  },
  triggerHeartbeat() {
    return LocalAPI.post<ApiResult<any>>(`/trigger`, {});
  },
  getSystemStatus() {
    return LocalAPI.get<ApiResult<any>>(`/status`);
  },
  sentDataService(data: any) {
    return Services.post<ApiResult<any>>(`/fingerprint`, data);
  },
};
